import React, {useEffect} from "react";
import Block, {Section} from "../Block";
import ShowItem from "../ShowItem";
import {useTranslation} from "react-i18next";
import {Col, Row} from "react-bootstrap";
import CmpLayoutPreview from "./CmpLayoutPreview";
import {useDebug, useFormattedLanguage} from "../utils";
import ColorShowItem from "./ColorShowItem";

export default function ShowPopupConfig({cmpConfig, preparedCmpConfigContent = []}) {
  const { t } = useTranslation();

  if (!cmpConfig) {
    return <></>
  }

  const mediumLabels = {
    sm: 7,
    md: 7,
    lg: 5,
    xl: 5
  }

  const formatLanguage = useFormattedLanguage(t)
  const formatLanguages = languages => languages?.map(formatLanguage)


  const ConfigShowItem = ({propertyName, format, label, ...props}) => {
    return <ShowItem
      label={label || t("cmp.popup." + propertyName)}
      value={format ? format(cmpConfig[propertyName]) : cmpConfig[propertyName]}
      placeholder={format ? format(cmpConfig.inheritedConfig?.[propertyName]) : cmpConfig.inheritedConfig?.[propertyName]}
      {...props} />
  }

  const colorShowItemProps = (propertyName) => {
    return {
      name: propertyName,
      value: cmpConfig[propertyName],
      placeholder: cmpConfig.inheritedConfig?.[propertyName]
    }
  }

  return <>
    <Block title={t("cmp.popup.configBlockTitle")}>
      <Section title={t("cmp.popup.general")}>
        <ConfigShowItem propertyName={"publisherName"}/>
        <ConfigShowItem propertyName={"privacyPolicyUrl"}/>
      </Section>
      <Section title={t("cmp.popup.dpoContact")}>
        <ConfigShowItem propertyName={"dpoEmail"}/>
        <ConfigShowItem propertyName={"dpoPostalAddress"}/>
      </Section>
      <Section title={t("cmp.popup.languages")}>
        <ConfigShowItem propertyName={"languages"} format={formatLanguages} array={true} />
        <ConfigShowItem propertyName={"defaultLanguage"} format={formatLanguage} />
      </Section>
      <Section title={t("cmp.popup.retry")}>
        <ConfigShowItem propertyName={"allowRetry"} bool={true} />
        <ConfigShowItem propertyName={"optinValidity"}/>
      </Section>
      <Section title={t("cmp.vendors.tabName")}>
        <ConfigShowItem propertyName={"includeAllIabVendors"} bool={true} />
      </Section>
    </Block>
    <Block title={t("cmp.popup.contentBlockTitle")}>
      {preparedCmpConfigContent.map(content => {
        return <Section key={content.language} title={formatLanguage(content.language)}>
          {content.attributes?.map(attribute => {
            return <ShowItem
              key={attribute.name}
              label={t(`cmp.${attribute.name}`)}
              value={attribute.content}
              placeholder={attribute.inheritedContent} />
          })}
        </Section>
      })}
    </Block>
    <Block title={t("cmp.popup.layoutBlockTitle")}>
      <Row>
        <Col md={8}>
          <Row>
            <Col md={6}>
              <ColorShowItem {...colorShowItemProps("linkColor")} />
              <ColorShowItem {...colorShowItemProps("activeSwitchColor")}/>
              <ColorShowItem {...colorShowItemProps("backgroundColor")}/>
            </Col>
            <Col md={6}>
              <ColorShowItem {...colorShowItemProps("buttonColor")}/>
              <ColorShowItem {...colorShowItemProps("headerColor")}/>
              <ColorShowItem {...colorShowItemProps("textColor")}/>
            </Col>
          </Row>
          <ConfigShowItem {...mediumLabels} label={"Logo"} propertyName={"logoFilename"}/>
          <ConfigShowItem {...mediumLabels} propertyName={"fontUrl"}/>
          <ConfigShowItem {...mediumLabels} propertyName={"fontSelector"}/>
          <ConfigShowItem {...mediumLabels} propertyName={"defaultTcfV2ConsentRequestLayoutVersion"}/>
        </Col>
        <Col md={4}>
          <Section title={"Preview"}>
            <CmpLayoutPreview {...(cmpConfig.inheritedConfig || cmpConfig)}/>
          </Section>
        </Col>
      </Row>
    </Block>
  </>
}
